
















































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import ejes from '@/mixins/axios/pmd_eje_rectors'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
//@ts-ignore
import EjeHeader from '@/components/headersSelect/eje'

@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    TablePPoa,
    EjeHeader
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
       columnasd:[
            
            
           
             
            {
                tag:'nombre_eje',
                data:'nombre_eje',
                active:true
            },
             {
                tag:'objetivo',
                data:'objetivo',
                active:true
            },
            
             {
                tag:'select_estrategia',
                data:'select',
                active:false
            },
              {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
       ],
   
    



        id:null as any,

      nombre_eje:'' as any,
      objetivo:'' as any,
         
              ejes:[] as any,
      
    }
  },
     mixins: [ejes],
     validations: {
    
           nombre_eje: {
      required,
    },

           objetivo: {
      
    },
   
         
     

   
  },
  methods:{
       clearstate(){
this.$store.commit('SETEJE',null);
this.$store.commit('SETESTRATEGIA',null);

 this.$router.push('/mun/general/pmd/ejes')
        },
          select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
this.$store.commit('SETEJE',row);
    this.$router.push('/mun/general/pmd/ejes/estrategias')
/*
 console.log(row);
 if(row.objetivo==''||row.objetivo==null){
    this.$router.push('/mun/general/pmd/ejes/objetivos')
 }else{
   this.$router.push('/mun/general/pmd/ejes/objetivos')
 }*/
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   
//this.getDataDepartamentos();

      
     },
      async eliminar(row){
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_PMD_EJE_RECTOR(row).then(response => {

                    if (response != null) {

 this.ejes=this.ejes.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar ejes, refresque la página");

                    }
 this.$root.$emit('loading', false);
                });
      },
     
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
                 this.nombre_eje=null;
                  this.objetivo=null;

    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_ejes').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.nombre_eje=row.nombre_eje;
  this.objetivo=row.objetivo;

          
             
 $('#ac_modal_ejes').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_PMD_EJE_RECTOR(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.ejes.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar ejes, refresque la página");

                    }    $("#ac_modal_ejes").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_PMD_EJE_RECTOR(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Eje modificado correctamente.");
  this.ejes=this.ejes.filter(item => item.id !== dat.id);
 this.ejes.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear ejes, refresque la página");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
            objetivo:this.objetivo,
        nombre_eje:this.nombre_eje,
        idpmd:this.$store.state.pmd_sel.id,
        idmunicipio:this.$store.state.user.usuario.id_municipio
    
}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idpmd:this.$store.state.pmd_sel.id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_PMD_EJE_RECTOR(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.ejes=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

